import {
  createUserConfig,
  DEFAULT_DATE_FORMAT_OPTION,
  DEFAULT_TIMEZONE_OPTION,
  EMPTY_OPTION
} from './model';
import type { Option, UserConfig, UserConfigConversation } from './types';

export type UserConfigDto = Partial<{
  timezone: Option;
  dateFormat: Option;
  defaultMarket: Option;
  defaultInsight: Option;
  homepage: Option;
  chatHistory: UserConfigConversation[];
  exportVideoExplainerSeen: boolean;
}>;

const resolveDefaultMarket = (data: UserConfigDto): Option =>
  data.defaultMarket ?? data.defaultInsight ?? EMPTY_OPTION;

const resolveHomepage = (data: UserConfigDto, defaultMarket: Option): Option =>
  data.homepage?.value.length ? data.homepage : defaultMarket;

export const parseUserConfigDto = (data: UserConfigDto): UserConfig => {
  const defaultMarket = resolveDefaultMarket(data);

  return createUserConfig({
    timezone: data.timezone ?? DEFAULT_TIMEZONE_OPTION,
    dateFormat: data.dateFormat ?? DEFAULT_DATE_FORMAT_OPTION,
    defaultMarket,
    homepage: resolveHomepage(data, defaultMarket),
    chatHistory: data.chatHistory ?? [],
    exportVideoExplainerSeen: data.exportVideoExplainerSeen ?? false
  });
};

export const toUserConfigSavePayload = (userConfig: UserConfig): UserConfig =>
  createUserConfig(userConfig);
